export const MODO_FIRMA_SIN_FIRMA_DOCUMENTOS = '0'
export const MODO_FIRMA_MANUSCRITA_DOCUMENTOS = '1'
export const MODO_FIRMA_ACEPTACION_EMAIL = '2'
export const MODO_FIRMA_SIN_DOBLE_FACTOR = '3'
export const MODO_FIRMA_CON_DOBLE_FACTOR = '4'
export const MODO_FIRMA_A_TRAVES_PLATAFORMA_EXTERNA = '5'

export const TIPOS_FIRMA_WEB = [
  MODO_FIRMA_MANUSCRITA_DOCUMENTOS,
  MODO_FIRMA_SIN_DOBLE_FACTOR,
  MODO_FIRMA_CON_DOBLE_FACTOR,
]
export const TIPOS_FIRMA_WEB_CON_DF = [MODO_FIRMA_CON_DOBLE_FACTOR]
export const TIPOS_FIRMA_WEB_SIN_DF = [
  MODO_FIRMA_MANUSCRITA_DOCUMENTOS,
  MODO_FIRMA_SIN_DOBLE_FACTOR,
]

/*Si el tipo de firma es 0: Nada )
Si el tipo de firma es 1: Debe usted desdcargar el documento, firmalo por sus medios....
Si el tipo de firma es 2: Estos no salen en la web
Si el tipo de firma es 3 (firma sin mas): Debe pulsar el bot�n de firmar para aceptar el documento.
Si el tipo de firma es 4: Debe pulsar el bot�n de firmar para aceptar el documento e indicar el segundo factor de verificai�n
Si el tipo de firma es 5: El mismo texto que en la 1 "Debe usted desdcargar el documento, firmalo por sus medios...."*/

export const STATUS_CERRADO = 'CERRADO'

const ICONO_MAP = {
  'a10.svg': { icon: 'A10Outline', color: '#E64848' },
  'd10.svg': { icon: 'D10Outline', color: '#426bba' },
}

const MIME_MAP = {
  'application/pdf': { icon: 'PdfOutline', color: '#E64848' },
  'application/vnd.ms-excel': { icon: 'XlsOutline', color: '#217346' },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    icon: 'XlsOutline',
    color: '#217346',
  },
  'application/vnd.ms-powerpoint': { icon: 'PptOutline', color: '#D24726' },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    icon: 'PptOutline',
    color: '#D24726',
  },
  'image/png': { icon: 'PngOutline', color: '#426bba' },
  'image/jpeg': { icon: 'JpgOutline', color: '#426bba' },
  'text/plain': { icon: 'TextAltOutline', color: '#666' },
}

export const getFileIcon = (fichero) => {
  if (fichero.icono && ICONO_MAP[fichero.icono.toLowerCase()]) {
    return ICONO_MAP[fichero.icono.toLowerCase()]
  }
  if (fichero.mime_type && MIME_MAP[fichero.mime_type]) {
    return MIME_MAP[fichero.mime_type]
  }
  return { icon: 'DocOutline', color: '#666' }
}

export const getActionableFile = (doc) => {
  const ficheros = doc.ficheros_a_firmar ?? []
  if (ficheros.length === 1) return ficheros[0]
  const firmables = ficheros.filter((f) => f.puede_firmar === 'S')
  if (firmables.length === 1) return firmables[0]
  return null
}

export const getAdjuntosCount = (doc) => (doc.ficheros_asociados ?? []).length

export const getNumeroExpediente = (doc) => {
  if (doc.id == null || doc.id === '') return null
  return String(doc.id)
}

export const enrichFileForSigning = (fichero, doc) => ({
  ...fichero,
  permitir_adjuntar_documentos: doc.permitir_adjuntar_documentos,
  tipos_2fa: doc.tipos_2fa ?? [],
  firma_2fa: doc.firma_2fa ?? 'N',
  codigo_tipo_doc: doc.codigo_tipo_doc,
  codigo_status: doc.codigo_status,
})
